module.exports = __webpack_public_path__ + "static/testi-1-3-c8017182c899c8bc983df822cdf0c877.jpg";